import moment from 'moment';

export const getDateDifference = (date1: string, date2: string) => {
    const startMoment = moment(date1);
    const endMoment = moment(date2);
    const differenceInDays = endMoment.diff(startMoment, 'days');
    return differenceInDays + 1;
};
